require('console-polyfill');
var $ = require('jquery');
var hg = {};

hg.getHtml = function (cfg) {
    var url = ((typeof cfg == 'object') ? cfg.url : cfg),
        datas = cfg.data,
        callback = cfg.callback;
    var dtd = $.Deferred();
    $.ajax({
        url: url + "?random=" + new Date().getTime(),
        type: "GET",
        data: datas,
        cache: false,
        dataType: "html",
        headers: {
            'ngrok-skip-browser-warning': 'true' //~~~
        },
        success: function (html) {
            if (callback && typeof callback == 'function') {
                callback("success", html);
            }
            dtd.resolve(html);
        },
        error: function () {
            if (callback && typeof callback == 'function') {
                callback("error", null);
            }
            dtd.reject();
        }
    });
    return dtd.promise();
};
// 获取远程数据方法，无缓存
var loadingCount = 0;
hg.getJson = function (cfg) {
    var url = ((typeof cfg == 'object') ? cfg.url : cfg),
        datas = cfg.data || '',
        callback = cfg.callback,
        contentType = cfg.contentType,
        method = cfg.type || 'GET';

    if (url.indexOf('?') == -1) {
        url += '?_=' + (new Date()).getTime();
    } else {
        url += '&_=' + (new Date()).getTime();
    }
    var dtd = $.Deferred();
    /* if(typeof datas == 'object'){
        datas['_']=(new Date()).getTime();
    }else{
        datas+='&_='+(new Date()).getTime();
    } */
    if (cfg.loading != false) {
        loadingCount++;
        // hg.loading.show(cfg.loadingText);
    }
    $.ajax({
        url: url,
        type: method,
        data: datas,
        cache: false,
        dataType: "json",
        contentType: contentType,
        headers: {
            'ngrok-skip-browser-warning': 'true'//~~~
        },
        beforeSend: function (xhr) {
            xhr.overrideMimeType("text/plain; charset=utf-8");
            // xhr.setRequestHeader("x-requested-with","XMLHttpRequest");
        }
    }).done(function (json) {
        var buState = 'error';
        // if (json && json.code == '0003') {
        //     setTimeout(() => {
        //         window.location.href = '/vlfront/sign/signIn?toUrl=' + encodeURIComponent(location.href);
        //     }, 1000);
        // }
        if (json && json.code == '0000') {
            buState = 'success';
            dtd.resolve(json);
        } else {
            dtd.reject(json || {});
        }
        /* if (callback && typeof callback == 'function') {
            callback(buState, json)
        } */
    }).fail(function (xhr, e) {
        if (xhr.status == 403) {
            // callback("error", { code:"403","codeMsg": "您没有此操作的权限，请联系管理员!" });
            dtd.reject({ code: "403", "codeMsg": "您没有此操作的权限，请联系管理员!" });
            return;
        }
        /* if (callback && typeof callback == 'function') {
            callback("error", { code:"5555","codeMsg": "服务器连接出错!" });
        } */
        dtd.reject({ code: "5555", "codeMsg": "服务器连接出错!" });
        return;
    }).always(function () {
        if (cfg.loading != false) {
            loadingCount--;
            if (loadingCount == 0) {
                // hg.loading.hide();
            }
        }
    });
    return dtd.promise();
};

hg.jsonp = function (cfg) {
    var url = ((typeof cfg == 'object') ? cfg.url : cfg),
        datas = cfg.data || '',
        callback = cfg.callback;
    var dtd = $.Deferred();
    $.ajax({
        url: url,
        data: datas,
        dataType: "jsonp",
        jsonp: 'jsonpCallback',
        timeout: 5000
    }).done(function (json) {
        dtd.resolve(json);
        if (callback && typeof callback == 'function') {
            callback("success", json);
        }
    }).fail(function () {
        dtd.reject({ "codeMsg": "服务器连接出错!" });
        if (callback && typeof callback == 'function') {
            callback("error", { "codeMsg": "服务器连接出错!" });
        }
    });
    return dtd.promise();
};

hg.url = {
    getUrl: function () {
        return window.location.href;
    },
    /*
     * 获取url参数，多个参数
     * //Get object of URL parameters
     * var allVars = $.getUrlVars();
     * //Getting URL var by its name
     * var getName = $.getUrlVar('name');
     */
    getUrlVars: function (strUrl) {
        var vars = {}, hash;
        var url = strUrl || window.location.href;

        // if (url.indexOf('#') > -1) {
        //     // url = url.slice(0, url.indexOf('#')); // bug ba?
        //     url = url.slice(url.indexOf('#') + 1);
        // }

        var hashes = [];
        if (url.indexOf('?') > -1) {
            hashes = url.slice(url.indexOf('?') + 1).split('&');
        }

        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars[hash[0]] = hash[1];
        }
        return vars;
    },
    getUrlVar: function (name, strUrl) {
        return hg.url.getUrlVars(strUrl)[name];
    }
};

/*
 * 通用正则表达式
 * floatNum匹配可精确到小数点后两位或者整数
 */
hg.regExp = {
    "cellphone": new RegExp('^(1[0-9]{10})$', 'g'),
    "number": new RegExp('^(\\d+$)', 'g'),
    "floatNum": new RegExp('^\\d+(\\.\\d{1,2})?$', 'g'),
    "Chinese": /[\u4E00-\u9FFF]/g,
    "email": /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/g,
    "float": /^([1-9]\d*|0)(\.\d+)?$/g,  // 整数或小数
    "int": /^[1-9]\d*$/g,  // 正整数
    "userName": new RegExp('^[a-zA-Z0-9\\!\\@\\#\\$\\%\\^\\&\\*\\-\\_]{2,15}$', 'g'),  // 数字字母特殊字符，2-15位
    "userName2":/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})$/,
    // 20190314WWL从后端拿来几个新的
    // 20190320WWL 发现后端给的这几个正则有问题..网上找了两个替换掉PWD和USERNAME
    // 190325 测试说，要跟前台一样
    "PWD": new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$'), // 6-20位数字+英文,
    "PWD2": new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$'), // 6-16位数字+英文,
    "EMAIL": new RegExp('^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'),
    "MOBILE": new RegExp('^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$'),
    "USERNAME": new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{3,15}$') // 3-15位数字+英文
};

/* 本对象暂时不支持checkbox和radio的值获取 */
hg.form = function (ele, hock) {
    var objs;
    if (!hock) {
        objs = $(ele).find('input,select,textarea');
    } else {
        objs = $(ele).find(hock);
    }
    return {
        val: function (data) {
            if (!data) {
                var result = {};
                objs.each(function () {
                    var tg = this.tagName;
                    var th = $(this);
                    var key = th.attr('name');

                    if (tg == 'INPUT' && this.type.toLowerCase() == 'radio') {
                        if (this.checked) {
                            result[key] = this.value;
                        }
                        return;
                    }
                    var value;
                    if (tg == 'INPUT' || tg == 'SELECT' || tg == 'TEXTAREA') {
                        value = th.val();
                    } else {
                        value = th.html();
                    }
                    if (key) {
                        result[key] = value;
                    }
                });
                return result;
            } else {
                objs.each(function () {
                    var tg = this.tagName;
                    var th = $(this);
                    var key = th.attr('name');
                    if (!key) { return; }
                    var val = data[key];

                    if (tg == 'INPUT' && this.type.toLowerCase() == 'radio') {
                        if (this.value == val) {
                            this.checked = true;
                        }
                        return;
                    }

                    if (tg == 'INPUT' || tg == 'SELECT' || tg == 'TEXTAREA') {
                        th.val(val);
                    } else {
                        th.html(val);
                    }
                });
                return this;
            }
        },
        valStr: function () {
            var result = this.val();
            var str = '';
            for (var i in result) {
                str += '&' + i + '=' + result[i];
            }
            return str;
        }
    };
};

hg.object = function (obj) {
    function A() { }
    A.prototype = obj;
    var o = new A();
    return o;
};

hg.inheritPrototype = function (Sub, Super) {
    var prototype = hg.object(Super.prototype);   // 创建对象
    prototype.constructor = Sub;   // 增强对象
    Sub.prototype = prototype;   // 自定对象
};

hg.generateUUID = function () {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};

hg.cookie = {
    get: function (c_name) {
        var c_start, c_end;
        if (document.cookie.length > 0) {
            c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    },
    set: function (c_name, value, expiredays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie = c_name + "=" + escape(value) +
            ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
    }
};

// 去掉字符串头尾空格
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/(^\s*)|(\s*$)/g, "");
    };
}

Array.prototype.contain = function (val) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] == val) {
            return true;
        }
    }
    return false;
};

$.cachedScript = function (url, options) {

    // allow user to set any option except for dataType, cache, and url
    options = $.extend(options || {}, {
        dataType: "script",
        cache: true,
        url: url
    });

    // Use $.ajax() since it is more flexible than $.getScript
    // Return the jqXHR object so we can chain callbacks
    return $.ajax(options);
};

// hg.loading=new ZLoading();
// hg.bridge=new Bridge();

hg.samllToBIG = function (n) {
    var fraction = ['角', '分'];
    var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    var unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var m = 0; m < fraction.length; m++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, m)) % 10] + fraction[m]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
};

hg.deleteArrayItemByValue = function (arr, i, value) {
    if (arr[i] === value) {
        arr.splice(i, 1);
    } else {
        hg.deleteArrayItemByValue(arr, ++i, value);
    }
};

hg.Calc = {
    mult: function (arg1, arg2) {   // 乘法
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try { m += s1.split(".")[1].length; } catch (e) { console.log(); }
        try { m += s2.split(".")[1].length; } catch (e) { console.log(); }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },
    divi: function (arg1, arg2) {   // 除法
        var t1 = 0, t2 = 0, r1, r2;
        try { t1 = arg1.toString().split(".")[1].length; } catch (e) { console.log(); }
        try { t2 = arg2.toString().split(".")[1].length; } catch (e) { console.log(); }
        r1 = Number(arg1.toString().replace(".", ""));
        r2 = Number(arg2.toString().replace(".", ""));
        return hg.Calc.mult((r1 / r2), Math.pow(10, t2 - t1));
    },
    add: function (arg1, arg2) {   // 加法
        var r1, r2, m;
        try { r1 = arg1.toString().split(".")[1].length; } catch (e) { r1 = 0; }
        try { r2 = arg2.toString().split(".")[1].length; } catch (e) { r2 = 0; }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
    },
    subt: function (arg1, arg2) {  // 减法
        var r1, r2, m, n;
        try { r1 = arg1.toString().split(".")[1].length; } catch (e) { r1 = 0; }
        try { r2 = arg2.toString().split(".")[1].length; } catch (e) { r2 = 0; }
        m = Math.pow(10, Math.max(r1, r2));
        n = (r1 >= r2) ? r1 : r2;
        // return ((arg1*m-arg2*m)/m).toFixed(n);
        return hg.Calc.toFixed(((arg1 * m - arg2 * m) / m), n);
    },
    toFixed: function (numb, n) {  // js的toFixed逢5的判断很糟糕，会精度不准比如1.025.toFixed，所以封装一个新的
        var num = String(numb);
        if (num.split('.')[1] && (num.split('.')[1])[n] == 5) {
            let num1 = String(num.split('.')[0]);
            let num2 = String(num.split('.')[1]);
            num2 = num2.substr(0, n) + "6";
            num = num1 + '.' + num2;
        }
        return Number(num).toFixed(n);
    },
    yuanToFen: function (yuan) {
        return hg.Calc.toFixed(hg.Calc.mult(Number(yuan), 100), 0);
    },
    fenToYuan: function (fen) {
        return hg.Calc.divi(Number(fen), 100);
    }
};

//判断浏览器版本
hg.checkIEVersion = function () {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }
    } else if (isEdge) {
        return 'edge';//edge
    } else if (isIE11) {
        return 11; //IE11
    } else {
        return -1;//不是ie浏览器
    }
}

 /**
 * 数字转整数 如 100000 转为10万
 * @param {需要转化的数} num
 * @param {需要保留的小数位数} point
 */
hg.tranNumber = function(num, point){
    let numStr = num.toString()
    //去小数
    let pointStr = numStr.split('.')[1];
    numStr = numStr.split('.')[0];
    // 十万以内直接返回
    if (numStr.length < 6) {
        if(pointStr && pointStr.length>0){
            pointStr = pointStr.substring(0,point);
            return numStr + '.' + pointStr;
        }
        else{
            return numStr;
        }
    }
    //大于8位数是亿
    else if (numStr.length > 8) {
        let decimal = numStr.substring(numStr.length - 8, numStr.length - 8 + point);
        return parseFloat(parseInt(num / 100000000) + '.' + decimal) + '亿';
    }
    //大于6位数是十万 (以10W分割 10W以下全部显示)
    else if (numStr.length > 5) {
        let decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
        return parseFloat(parseInt(num / 10000) + '.' + decimal) + '万';
    }
}

//判断有无adobe(pdf预览使用)
hg.isAcrobatPluginInstall = function() {
    //下面代码都是处理IE浏览器的情况
    if((window.ActiveXObject)||(navigator.userAgent.indexOf("Trident") > -1)) {
        for(var x = 2; x < 10; x++) {
            try {
                var oAcro = eval("new ActiveXObject('PDF.PdfCtrl." + x + "');");
                if(oAcro) {
                    return true;
                }
            } catch(e) {}
        }
        try {
            var oAcro4 = new ActiveXObject('PDF.PdfCtrl.1');
            if(oAcro4){
                return true;
            }
        } catch(e) {}
        try {
            var oAcro7 = new ActiveXObject('AcroPDF.PDF.1');
            if(oAcro7){
                return true;
            }
        } catch(e) {}
    }else{
        //chrome和FF、safrai等其他浏览器
        return true;
    }
};

module.exports = hg;



// WEBPACK FOOTER //
// ./component/common.js